const isQABot = () => {
  return navigator.userAgent === 'qa-automation-bot';
};

export default isQABot;
